import { Box, Stack } from "@chakra-ui/react";
import { POSTS_TYPE_VALUE_ARTICLE } from "@raiden/library/constants/posts";
import { initString } from "@raiden/library/helpers/form/initString";
import useRouterArray from "@raiden/library/hooks/router/useRouterArray";
import useRouterString from "@raiden/library/hooks/router/useRouterString";
import generateApiUri from "@raiden/library/libraries/utils/generateApiUri";
import { useMemo } from "react";
import CenteredContent from "../../../components/CenteredContent";
import SearchInfiniteProvider from "../../SearchInfinite/SearchInfiniteProvider";
import { useSearchInfinite } from "../../SearchInfinite/useSearchInfinite";
import Filters from "./Filters";
import Results from "./Results";

/**
 * @typedef {object} NewsSearchFormValues
 * @property {string} term
 * @property {string[]} category_id
 */

/** @type {NewsSearchFormValues} */
export const NEWS_SEARCH_FORM_DEFAULT_VALUES = {
  term: "",
  category_id: [],
};

/**
 * @typedef {Object} Props
 * @property {import("swr").SWRResponse<import("@raiden/library/types/Api/ApiResponse").ApiResponse<import("@raiden/library/types/PostCategory").PostCategory[]>>} swrResponsePostCategories
 *
 * @param {Props} props
 */
function Handler({ swrResponsePostCategories }) {
  const term = useRouterString("term");
  const category_id = useRouterArray("category_id[]");

  const initialFields = useMemo(() => {
    /** @type {NewsSearchFormValues} */
    const submittedFields = {
      term: initString(term).trim(),
      category_id,
    };
    return submittedFields;
  }, [category_id, term]);

  const searchInfinite = useSearchInfinite({
    autoSubmit: true,
    defaultValues: NEWS_SEARCH_FORM_DEFAULT_VALUES,
    initialFields,
    useRouterUrl: true,
    generateUrl: (fields, key) =>
      generateApiUri({
        id: "@posts.search",
        query: {
          ...fields,
          page: key + 1,
          per_page: 6,
          type: [POSTS_TYPE_VALUE_ARTICLE],
          fields: [
            "post.current_revision",
            "post.categories",
            "post.revision.cover",
          ],
        },
      }),
  });

  return (
    <CenteredContent maxWidth="calc(1280px + 2rem)">
      <SearchInfiniteProvider {...searchInfinite}>
        <Stack
          direction={{ base: "column", lg: "row" }}
          spacing="0"
          align="stretch">
          <Box width={{ lg: "25%" }} pr={{ lg: ".5rem" }}>
            <Filters swrResponsePostCategories={swrResponsePostCategories} />
          </Box>

          <Box
            width={{ lg: "75%" }}
            backgroundColor="#fff"
            py="1rem"
            px="1rem"
            pl={{ base: "1rem", lg: "1.5rem" }}>
            <Results />
          </Box>
        </Stack>
      </SearchInfiniteProvider>
    </CenteredContent>
  );
}

export default Handler;
